import { useSearchResultItem } from '../hooks'

const SearchResultChoice = ({ mapId, item }) => {
  const [{ label }, { onClick }] = useSearchResultItem(mapId, item)
  
  return (
    <li className="search--choice-listing" onClick={onClick}>{label}</li>
  )
}

export default SearchResultChoice